export function isLoggedIn() {
  try {
    return Boolean(localStorage.getItem('adeeb-token') && localStorage.getItem('adeeb-user'));
  } catch {
    return false;
  }
}

export function requireAuth(navigate, redirectTo) {
  if (isLoggedIn()) return true;
  const search = redirectTo ? `?redirect=${encodeURIComponent(redirectTo)}` : '';
  navigate(`/login${search}`);
  return false;
}

// Only same-site paths may be used as a post-sign-in destination.
export function safeRedirect(path) {
  return typeof path === 'string' && /^\/(?![/\\])/.test(path) ? path : '';
}

// A newcomer who must verify their email first keeps their destination
// (for example the subscribe page) until the verification link is opened.
export function rememberPostAuthRedirect(path) {
  try {
    const safe = safeRedirect(path);
    if (safe) localStorage.setItem('adeeb-post-auth-redirect', safe);
  } catch { /* storage unavailable */ }
}

export function takePostAuthRedirect() {
  try {
    const path = safeRedirect(localStorage.getItem('adeeb-post-auth-redirect'));
    localStorage.removeItem('adeeb-post-auth-redirect');
    return path;
  } catch {
    return '';
  }
}
